import type { OngoingDownload } from '../model/ongoingDownload';

/**
 * Calculates presentable numeric percentage of transfer progress
 * @param transferRequest {Object of the TransferRequest}
 */
export const getProgressPercent = (transferRequest: OngoingDownload) => {
  return !transferRequest.downloadProgress || (transferRequest.downloadProgress.totalSize === 0)
    ? 0
    : Math.round(transferRequest.downloadProgress.transferred * 100 / transferRequest.downloadProgress.totalSize);
};
